import { Grid, MenuItem, TextField } from '@mui/material';
import { legalClientTypes } from '../../../Interfaces/ILegalClientType';

type IProps = {
  value: number;
  onChange: (value: number) => void;
};

// const getUpdatedBusinessForm = (
//   selectedLegalClientType: number,
//   currentBusinessForm: number
// ): number => {
//   if (selectedLegalClientType === 1) {
//     return 1; // Natural Person
//   } else if (currentBusinessForm === 1) {
//     return 2; // Default to "Einzelunternehmen" if switching from natural person
//   } else {
//     return currentBusinessForm; // Keep current Business Form
//   }
// };
//
export const LegalClientTypeInput = ({ value, onChange }: IProps) => {
  return (
    <Grid item xs={3}>
      <TextField
        select
        label='Typ'
        fullWidth
        size='small'
        value={value}
        onChange={event => {
          onChange(
            Number(event.target.value)
            // TODO: set business form somewhere else
            // idBusinessForm
          );
        }}
      >
        {legalClientTypes.map(type => (
          <MenuItem value={type.idLegalClientType}>
            {type.LegalClientType}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  );
};
